import React from "react"
import styled from "styled-components"
import Link from "next/link"
import WinItButton from "~/components/WinItButton"

const Container = styled.div`
  margin: 0 1em;
  ${props => props.theme.media.mobile`
    margin: 0.4375em 0;
  `};
`

const SubmitTicketButton = () => {
  return (
    <Container>
      <Link href="/traffic-tickets" passHref>
        <WinItButton
          as="a"
          color="green"
          shape="round"
          fontSize="0.75em"
          padding="0 25px"
          height={50}
        >
          SUBMIT TICKET
        </WinItButton>
      </Link>
    </Container>
  )
}

export default SubmitTicketButton
